<template>
  <div
    class="app-wrapper" :class="{hideSidebar:!sidebar.opened}">
    <navbar></navbar>

    <sidebar class="sidebar-container"></sidebar>
    <modal v-if="modal.show">
    </modal>
    <div class="main-container">
      <app-main></app-main>
    </div>
  </div>
</template>

<script>
  import {Navbar, Sidebar, AppMain} from './components/index'
  import modal from './components/popUpModal/modal'


  export default {
    name: 'Layout',

    components: {
      Navbar,
      Sidebar,
      AppMain,
      modal


    },

    computed: {
      sidebar() {
        return this.$store.state.app.sidebar
      },
      modal() {
        return this.$store.state.app.modal;

      },


    },
    //this is just temporary
    methods: {

      refreshData() {
        this.getInAppNotifications().then(success => {
          //append the notifications to vuex
          console.log('', success)

        }).catch(error => {

        });
        console.log('data is being refreshed');
        console.log(this.timer)
      },
      getInAppNotifications() {
        return new Promise((resolve, reject) => {
          get('getNotifications').then(success => {
            resolve(success);

          }).catch(error => {
            reject(error)

          })

        })
      },

      cancelAutoUpdate() {
        clearInterval(this.timer)
      }

    },

    created() {
      // post('pushNotification', {message: 'TestNotification', statusCode: 0}).then(success => {
      // }).catch(error => {
      //
      // });


      // this.refreshData();
      //
      // // the function is being called every 3S
      // this.timer = setInterval(this.refreshData, 3000)

    },

    beforeDestroy() {
      clearInterval(this.timer)
    },
    data() {
      return {timer: ''}
    }

  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../styles/Mixin.scss";

  .app-wrapper {
    @include clearfix;
    min-height: 100%;
    height: 100%;
    width: 100%;
    background: url('../../assets/background.jpg');
    background-attachment: fixed;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    .main-container {
      height: calc(100% - 64px);
      overflow: auto;
    }
  }


</style>



// WEBPACK FOOTER //
// src/views/layout/layout.vue